import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import BookingTable from "./Components/BookingTable";
import api from "../../../api/axios";
import LoadingScreen from "../../../Components/LoadingScreen-inner";

const Index = () => {
  const [summary, setSummary] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [bookingData, setBookingData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    try {
      const [summaryRes, chartRes, todayRes] = await Promise.all([
        api.get("/pms/dashboard/summary"),
        api.get("/pms/dashboard/reservations-chart"),
        api.get("/pms/dashboard/today-bookings"),
      ]);

      setSummary(summaryRes.data);
      setChartData(chartRes.data);
      setBookingData(todayRes.data);
    } catch (err) {
      console.error("Dashboard API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatRupee = (amount) => {
    if (amount === null || amount === undefined) return "₹0";
    return "₹" + Number(amount).toLocaleString("en-IN");
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      {/* SUMMARY CARDS */}
      <div className="row g-3 mb-3">
        {summary &&
          [
            {
              title: "Total Booking",
              value: summary.totalBooking,
              per: summary.bookingChange + "%",
              bg: "bg-success",
              text: "From last month",
            },
            {
              title: "Total Amount",
              value: summary.totalAmount,
              per: summary.amountChange + "%",
              bg: "bg-primary",
              text: "From last month",
            },
            {
              title: "Total Customer",
              value: summary.totalCustomer,
              per: "",
              bg: "",
              text: "",
            },
            {
              title: "Total Revenue",
              value: summary.totalRevenue,
              per: summary.revenueChange + "%",
              bg: "bg-primary",
              text: "From last month",
            },
          ].map((data, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <div className="card h-100 shadow-sm">
                <div className="card-body d-flex flex-column justify-content-between">
                  <h6 className="text-muted mb-2">{data.title}</h6>

                  <h2 className="fw-semibold">
                    {["Total Amount", "Total Revenue"].includes(data.title)
                      ? formatRupee(data.value)
                      : data.value}
                  </h2>

                  {(data.per || data.text) && (
                    <div className="d-flex align-items-center mt-2">
                      {data.per && (
                        <span className={`badge ${data.bg} me-2`}>
                          {data.per}
                        </span>
                      )}
                      {data.text && (
                        <span className="text-muted small">{data.text}</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>

      <div className="row g-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h6 className="card-title">Reservations</h6>
            </div>
            <div className="card-body">
              {chartData && (
                <Chart
                  options={{
                    chart: {
                      height: 280,
                      type: "line",
                      toolbar: { show: false },
                    },
                    labels: chartData.labels,
                    stroke: { width: [0, 4] },
                    colors: ["#1E88E5", "#FF9800"],
                  }}
                  series={[
                    {
                      name: "Booking Confirmed",
                      type: "column",
                      data: chartData.confirmed,
                    },
                    {
                      name: "Booking Pending",
                      type: "line",
                      data: chartData.pending,
                    },
                  ]}
                  height={280}
                  type="line"
                />
              )}
            </div>
          </div>
        </div>

        {/* TODAY BOOKING LIST */}
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h6 className="card-title">Today Booking List</h6>
            </div>
            <div className="card-body">
              <BookingTable bookingData={bookingData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
